import React from 'react';
import { Link } from 'react-router-dom';
import './LandingPage.css';

export default function TermsPage() {
    return (
        <div className="landing">
            <header className="landing-header">
                <div className="container">
                    <Link to="/" className="logo">🏗️ Wrangler</Link>
                </div>
            </header>

            <main className="container" style={{ padding: '4rem 1rem', maxWidth: '800px' }}>
                <h1 style={{ marginBottom: '2rem' }}>Terms of Service</h1>
                <p style={{ color: '#666', marginBottom: '2rem' }}>Last updated: January 2026</p>

                <section style={{ marginBottom: '2rem' }}>
                    <h2>1. Acceptance of Terms</h2>
                    <p>By accessing or using Wrangler, you agree to be bound by these Terms of Service and all applicable laws and regulations. If you do not agree with any of these terms, you are prohibited from using or accessing this site.</p>
                </section>

                <section style={{ marginBottom: '2rem' }}>
                    <h2>2. Use License</h2>
                    <p>Permission is granted to temporarily download one copy of the materials (information or software) on Wrangler's website for personal, non-commercial transitory viewing only. This is the grant of a license, not a transfer of title.</p>
                </section>

                <section style={{ marginBottom: '2rem' }}>
                    <h2>3. Account Terms</h2>
                    <ul style={{ paddingLeft: '1.5rem', marginTop: '1rem' }}>
                        <li>You must be 13 years or older to use this Service.</li>
                        <li>You must provide your legal full name, a valid email address, and any other information requested in order to complete the signup process.</li>
                        <li>You are responsible for maintaining the security of your account and password.</li>
                        <li>You are responsible for all Content posted and activity that occurs under your account.</li>
                    </ul>
                </section>

                <section style={{ marginBottom: '2rem' }}>
                    <h2>4. Prohibited Uses</h2>
                    <p>You may not use the Service for any illegal or unauthorized purpose. You must not, in the use of the Service, violate any laws in your jurisdiction (including but not limited to copyright or trademark laws).</p>
                    <p>We reserve the right to remove any content or terminate any account that we determine, in our sole discretion, is unlawful, offensive, threatening, libelous, defamatory, pornographic, or otherwise objectionable.</p>
                </section>

                <section style={{ marginBottom: '2rem' }}>
                    <h2>5. Governing Law</h2>
                    <p>These terms and conditions are governed by and construed in accordance with the laws of South Africa and you irrevocably submit to the exclusive jurisdiction of the courts in that State or location.</p>
                </section>
            </main>

            <footer className="landing-footer">
                <div className="container">
                    <p>© 2024 Wrangler.co.za. Made with ❤️ in South Africa.</p>
                </div>
            </footer>
        </div>
    );
}
